import { render, staticRenderFns } from "./ContactAddModal.vue?vue&type=template&id=235e9676&"
import script from "./ContactAddModal.vue?vue&type=script&lang=js&"
export * from "./ContactAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContactAddModal.vue"
export default component.exports